<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Kulvinder Kherteru is a devoted daughter-in-law, a wife and a mother. She has always had a passion for reading books since childhood. In her late 40s, she obtained her GCSE in English within six months and completed her BA Honour’s degree over the period of eight years. She has been working in Special Needs Education for 19 years to date and continues to do so.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?622b7d6e